/**
 * 全局错误处理工具
 * 提供统一的错误处理方法和API错误处理
 */

/**
 * 处理API错误
 * @param {Object} res - API响应对象
 * @param {string} defaultMessage - 默认错误消息
 * @param {Object} vm - Vue实例，用于显示消息
 */
export function handleApiError(res, defaultMessage, vm) {
    const message = res.msg || defaultMessage
    if (vm && vm.$message) {
        vm.$message.error(message)
    } else {
        console.error('API Error:', message)
    }
    console.error('API Error Details:', res)
}
/**
 * 处理通用错误
 * @param {Error|Object} error - 错误对象
 * @param {string} defaultMessage - 默认错误消息
 * @param {Object} vm - Vue实例，用于显示消息
 */
export function handleError(error, defaultMessage, vm) {
    const message = error.message || defaultMessage
    if (vm && vm.$message) {
        vm.$message.error(message)
    } else {
        console.error('Error:', message)
    }
    console.error('Error Details:', error)
}

/**
 * 处理网络错误
 * @param {Error} error - 网络错误对象
 * @param {Object} vm - Vue实例，用于显示消息
 */
export function handleNetworkError(error, vm) {
    const message = '网络连接失败，请检查网络设置'
    if (vm && vm.$message) {
        vm.$message.error(message)
    } else {
        console.error('Network Error:', message)
    }
    console.error('Network Error Details:', error)
}

/**
 * 处理表单验证错误
 * @param {Object} errors - 验证错误对象
 * @param {Object} vm - Vue实例，用于显示消息
 */
export function handleValidationError(errors, vm) {
    const message = '表单验证失败，请检查输入内容'
    if (vm && vm.$message) {
        vm.$message.error(message)
    } else {
        console.error('Validation Error:', message)
    }
    console.error('Validation Error Details:', errors)
}

/**
 * 创建错误处理器的工厂函数
 * @param {Object} vm - Vue实例
 * @returns {Object} 包含所有错误处理方法的对象
 */
export function createErrorHandler(vm) {
    return {
        handleApiError: (res, defaultMessage) => handleApiError(res, defaultMessage, vm),
        handleError: (error, defaultMessage) => handleError(error, defaultMessage, vm),
        handleNetworkError: (error) => handleNetworkError(error, vm),
        handleValidationError: (errors) => handleValidationError(errors, vm)
    }
}

